<app-header></app-header>
<section class="section">
  <!-- Section Start -->
  <section class="my-4 bg-light d-table w-100">
    <h4 class="text-center title">{{'EventPage.all' |translate}}</h4>
  </section>
  <!-- Start Events -->
  <div class="container">
    <div class="row justify-content-end mb-2">
      <div class="col-lg-9 col-md-8 col-12">
        <div class="d-flex justify-content-end align-items-center">
          <div class="section-title">
            <h5 class="fs-6">
              {{'EventPage.Showing' |translate}} {{ events.length }} {{'EventPage.events_of' |translate}} {{ totalItems }} {{'EventPage.results' |translate}}
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-4 col-12 pt-2">
        <div class="card shadow rounded border-0 sidebar sticky-bar">
          <div class="card-body">
            <!-- Categories -->
            <div class="widget mt-3 pt-2">
              <h6 class="widget-title">{{'EventPage.Categories' |translate}}</h6>
              <ng-select
                [items]="categories"
                bindLabel="name"
                bindValue="id"
                placeholder="{{'EventPage.select_category' |translate}}"
                [(ngModel)]="category"
                name="category"
                id="event-category"
                class="form-control"
              >
              </ng-select>
            </div>
            <!-- Date -->
            <div class="widget mt-3 pt-2">
              <h6 class="widget-title">{{'Sellers.AdvanceSales.StartDate' |translate}}</h6>
              <input
                class="form-control"
                placeholder="{{'EventPage.Choose_range' |translate}}"
                [owlDateTimeTrigger]="dt1"
                [owlDateTime]="dt1"
                [selectMode]="'range'"
                [(ngModel)]="dateRange"
              />
              <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
            </div>
            <!-- SEARCH -->
            <div class="widget mt-3 pt-2">
              <h6 class="widget-title">{{'Welcome.Search' |translate}}</h6>
              <form role="search" method="get" id="search">
                <div class="input-group mb-3 border rounded">
                  <input
                    placeholder="{{'EventPage.Search_by' |translate}}"
                    [(ngModel)]="searchKey"
                    type="text"
                    name="name"
                    class="form-control"
                  />
                  <button
                    type="submit"
                    class="input-group-text bg-primary text-white border-0"
                    id="searchsubmit"
                    (click)="fetchEvents()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- Events List -->
      <div class="col-lg-9 col-md-8 col-12">
        <div class="row">
          <!-- Events -->
          <div class="col-lg-4 col-sm-6 pt-2" *ngFor="let event of events">
            <div class="card shop-list border-0 position-relative">
              <ul class="label list-unstyled mb-0">
                <a
                  [routerLink]="['/', event.code]"
                  [queryParams]="{ c: event.prodId, s: 1 }"
                  ><li>
                    <span class="badge badge-link rounded-pill bg-success">
                      {{ event.sellerName }} - {{ event.eventCategory }}
                    </span>
                  </li></a
                >
              </ul>
              <div
                class="shop-image position-relative overflow-hidden rounded shadow"
              >
                <a
                  [routerLink]="['/', event.code]"
                  [queryParams]="{ c: event.prodId, s: 1 }"
                  ><img
                    src="{{ event.image }}"
                    class="img-fluid event-img-size"
                    alt="{{ event.sellerName }}"
                /></a>
              </div>
              <div class="card-body content pt-4 p-2">
                <a
                  [routerLink]="['/', event.code]"
                  [queryParams]="{ c: event.prodId, s: 1 }"
                  class="text-dark product-name fs-6"
                  >{{ event.eventName }}</a
                >
                <div class="d-flex justify-content-between mt-1">
                  <a
                    [routerLink]="['/', event.code]"
                    [queryParams]="{ c: event.prodId, s: 1 }"
                    ><h6 class="text-muted small mb-0 mt-1">
                      <i class="fas fa-calendar-alt"></i> {{'Sellers.AdvanceSales.StartDate' |translate}}:
                      {{ event.startDate | date : "mediumDate" }}
                    </h6></a
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- PAGINATION START -->
          <div *ngIf="totalItems > 0" class="row justify-content-center">
            <div class="col-auto pt-4">
              <pagination
                [boundaryLinks]="true"
                [totalItems]="totalItems"
                [maxSize]="5"
                (pageChanged)="onPageChanged($event)"
                [(ngModel)]="currentPage"
                [itemsPerPage]="itemsPerPage"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
              >
              </pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>
